
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 1.688A7.3 7.3 0 0116.313 9 7.3 7.3 0 019 16.313 7.3 7.3 0 011.688 9 7.3 7.3 0 019 1.688z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M9 6.579a.84.84 0 01.84.84v6.541a.84.84 0 01-1.68 0V7.418a.84.84 0 01.84-.84zm0-3.378a.84.84 0 01.84.84v.27a.84.84 0 01-1.68 0v-.27a.84.84 0 01.84-.84z","clip-rule":"evenodd"}})])
          )
        }
      }
    